import React from "react";

export function UserCircleIcon({ size = 20, color = "#737387" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 2.29199C5.74289 2.29199 2.29175 5.74313 2.29175 10.0003C2.29175 14.2575 5.74289 17.7087 10.0001 17.7087C14.2573 17.7087 17.7084 14.2575 17.7084 10.0003C17.7084 5.74313 14.2573 2.29199 10.0001 2.29199ZM1.04175 10.0003C1.04175 5.05277 5.05253 1.04199 10.0001 1.04199C14.9476 1.04199 18.9584 5.05277 18.9584 10.0003C18.9584 14.9479 14.9476 18.9587 10.0001 18.9587C5.05253 18.9587 1.04175 14.9479 1.04175 10.0003ZM10.0001 5.62533C8.96455 5.62533 8.12508 6.46479 8.12508 7.50033C8.12508 8.53586 8.96455 9.37533 10.0001 9.37533C11.0356 9.37533 11.8751 8.53586 11.8751 7.50033C11.8751 6.46479 11.0356 5.62533 10.0001 5.62533ZM12.068 9.8433C12.7163 9.2707 13.1251 8.43326 13.1251 7.50033C13.1251 5.77444 11.726 4.37533 10.0001 4.37533C8.27419 4.37533 6.87508 5.77444 6.87508 7.50033C6.87508 8.43326 7.28389 9.2707 7.93215 9.8433C6.32103 10.6153 5.20841 12.2612 5.20841 14.167V15.0003C5.20841 15.3455 5.48824 15.6253 5.83341 15.6253C6.17859 15.6253 6.45841 15.3455 6.45841 15.0003V14.167C6.45841 12.211 8.04407 10.6253 10.0001 10.6253C11.9561 10.6253 13.5417 12.211 13.5417 14.167V15.0003C13.5417 15.3455 13.8216 15.6253 14.1667 15.6253C14.5119 15.6253 14.7917 15.3455 14.7917 15.0003V14.167C14.7917 12.2612 13.6791 10.6153 12.068 9.8433Z"
        fill={color}
      />
    </svg>
  );
}
